import { Box, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import CustomButton from "components/atoms/CustomButton";
import CustomRightDrawer from "components/atoms/CustomRightDrawer";
import React from "react";
import GenerateResultModal from "./GenerateResultModal";
import CustomModal from "components/atoms/CustomModal";
import ImportRecordModal from "./ImportRecordModal";
import { useThemeCtx } from "store/contextStore/theme/ThemeStore";
import AddIcon from "@mui/icons-material/Add";
import CustomTabPanel from "components/atoms/CustomTabPanel";
import { useParams } from "react-router-dom";
import { useCustomQuery } from "store/hooks/react-query/query/useQuery";
import {
  GET_PATIENT_VISITS,
  PATIENTS_EXTERNAL_MEDICAL_REDCORDS,
} from "utils/reactQueryKeys";
import CustomDatePicker from "components/atoms/DatePicker";
import CustomLoader from "components/atoms/CustomLoader";
import VisitHistoryTable from "components/molecules/tabels/patient/VisitHistoryTable";
import SearchBar from "components/atoms/SearchBar";
import ImportedRecordsTable from "components/molecules/tabels/patient/ImportedRecordsTable";
import Pagination from "components/molecules/pagination/Pagination";
import DateRangePicker from "components/atoms/dateRangePicker/DateRangePicker";
import { useSanitizeQueryParams } from "utils/sanitizeQuery";
const navItems = [
  {
    label: "Visit entries",
    id: 0,
  },
  {
    label: "Imported Records",
    id: 1,
  },
];

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

const formatDate = (date) => {
  if (!date) return;

  const copy = new Date(date);
  return [padTo2Digits(copy.getMonth() + 1), copy.getFullYear()].join("-");
};

const VisitEntries = () => {
  const { id } = useParams();
  const [date, setdate] = React.useState(null);

  //get all patients visits
  const { data: visits, isLoading } = useCustomQuery(
    [GET_PATIENT_VISITS, id, { date: formatDate(date) }],
    {
      url: `/visit/visits/${id}`,
      method: "post",
      data: { date: formatDate(date) },
      avoidCancelling: true,
    },
    {
      refetchOnWindowFocus: false,
    }
  );
  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
          mt: 2,
        }}
      >
        <CustomDatePicker
          type="date"
          views={["year", "month"]}
          date={date}
          setdate={setdate}
          placeholder="Select Month/Year"
          disableFuture={false}
        />
      </Box>
      {isLoading ? (
        <CustomLoader />
      ) : visits?.data?.length ? (
        <VisitHistoryTable data={visits?.data} />
      ) : (
        "No Data Found"
      )}
    </Stack>
  );
};
const LIMIT = 10;

const ImportedRecords = () => {
  const { id } = useParams();
  const [date, setdate] = React.useState([]);
  const [search, setsearch] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);

  //get medical records
  const { data: medicalRecords, isLoading } = useCustomQuery(
    [
      PATIENTS_EXTERNAL_MEDICAL_REDCORDS,
      id,
      {
        startDate: formatDate(date && date[0]),
        endDate: formatDate(date && date[1]),
        search,
        currentPage,
      },
    ],
    {
      url: useSanitizeQueryParams(
        `/visit/patients/${id}/medical-records?page=${currentPage}&limit=${LIMIT}&search=${search}&startDate=${date[0]}&endDate=${date[1]}`
      ),
      method: "get",
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleReset = () => {
    setsearch("");
    setdate([]);
  };

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", lg: "center" },
          justifyContent: "space-between",
          width: "100%",
          gap: 2,
          flexDirection: { xs: "column", lg: "row" },
          mt: 2,
        }}
      >
        <SearchBar search={search} setsearch={setsearch} placeholder="Search" />
        <Stack direction={"row"} spacing={1}>
          <DateRangePicker
            values={date}
            setValues={setdate}
            position="left"
            placeholder="Select date range"
            calendarSx={{
              right: {
                xs: -150,
                sm: -250,
                lg: 5,
              },
            }}
          />
          <CustomButton
            text={"Reset"}
            variant="outlined"
            onClick={handleReset}
          />
        </Stack>
      </Box>
      <Stack spacing={1} width={"100%"}>
        {isLoading ? (
          <CustomLoader />
        ) : medicalRecords?.data?.results?.length ? (
          <ImportedRecordsTable data={medicalRecords?.data?.results} />
        ) : (
          "No Data Found"
        )}
        <Pagination
          currentPage={currentPage}
          totalCount={medicalRecords?.data?.count || 10}
          pageSize={LIMIT}
          activeColor="secondary.main"
          onPageChange={handlePageChange}
        />
      </Stack>
    </Stack>
  );
};
function VisitHistory() {
  const { state } = useThemeCtx();

  const modalRef = React.useRef(null);
  const modalRef1 = React.useRef(null);

  const [value, setValue] = React.useState(0);

  const toggleModal = () => {
    modalRef?.current?.handleToggle();
  };
  const toggleModal1 = () => {
    modalRef1?.current?.handleToggle();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Paper sx={{ p: 2, minHeight: "70vh" }}>
        <Stack
          direction={{ xs: "column", lg: "row" }}
          alignItems={{ xs: "start", lg: "center" }}
          justifyContent={"space-between"}
          width={"100%"}
          spacing={1}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Visit History
          </Typography>
          <Stack direction={"row"} spacing={2}>
            <CustomButton
              text={"Import record"}
              color="secondary"
              onClick={toggleModal1}
              startIcon={<AddIcon />}
            />
            <CustomButton
              text={"Generate Report"}
              color="secondary"
              onClick={toggleModal}
              startIcon={
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.99999 6.66493L5 6.67188"
                    stroke="white"
                    strokeLinecap="round"
                  />
                  <path
                    d="M2 3.33301C2 2.22844 2.89543 1.33301 4 1.33301H9.2759C9.74377 1.33301 10.1968 1.49704 10.5563 1.79657L12 2.99967L13.2804 4.06665C13.7364 4.44664 14 5.00953 14 5.60309V12.6663C14 13.7709 13.1046 14.6663 12 14.6663H4C2.89543 14.6663 2 13.7709 2 12.6663V3.33301Z"
                    stroke="white"
                  />
                  <path d="M11 12H5" stroke="white" strokeLinecap="round" />
                  <path
                    d="M11 9.33301H5"
                    stroke="white"
                    strokeLinecap="round"
                  />
                </svg>
              }
            />
          </Stack>
        </Stack>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="nav tabs example"
          variant="scrollable"
          scrollButtons={"auto"}
          allowScrollButtonsMobile
          indicatorColor="secondary"
          sx={{
            overflow: "hidden !important",

            "& .MuiTabs-indicator": {
              bgcolor: state.lightTheme ? "black" : "white",
            },
            "& .MuiTab-root.Mui-selected": {
              color: "text.primary",
            },
          }}
        >
          {navItems.map((item) => (
            <Tab
              key={item.id}
              component="a"
              onClick={(event) => {
                event.preventDefault();
                setValue(item.id);
              }}
              {...item}
            />
          ))}
        </Tabs>
        <CustomTabPanel value={value} index={0}>
          <VisitEntries />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ImportedRecords />
        </CustomTabPanel>
      </Paper>

      <CustomRightDrawer
        ref={modalRef}
        drawerSx={{
          width: {
            xs: "90vw",
            sm: "70vw",
            md: "60vw",
          },
        }}
        title="Generate Report"
        subTitle=""
      >
        <GenerateResultModal toggleModal={toggleModal} />
      </CustomRightDrawer>
      <CustomModal
        ref={modalRef1}
        childrenContSx={{
          width: {
            xs: "90vw",
            sm: "65vw",
            lg: "45vw",
          },
          p: 6,
        }}
      >
        <ImportRecordModal toggleModal={toggleModal1} />
      </CustomModal>
    </>
  );
}

export default VisitHistory;
